import { render, staticRenderFns } from "./ShowNumerations.vue?vue&type=template&id=4dba552b"
import script from "./ShowNumerations.vue?vue&type=script&lang=js"
export * from "./ShowNumerations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports